import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";

export class LoginForm extends React.Component {

    render() {

        const {handleSubmit, errors} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Field name="email"
                       label="メールアドレス"
                       err={errors.email}
                       component={renderTextField}
                       type="text"/>

                <Field name="password"
                       label="パスワード"
                       err={errors.password}
                       component={renderTextField}
                       type="password"/>

            </form>
        )
    }
}

LoginForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

LoginForm = reduxForm({
    form: 'login'
})(LoginForm);


// WEBPACK FOOTER //
// ./src/forms/login.js